<div class="role-page page">
  <app-breadcrumbs [breadcrumbs]="breadcrumbs" />
  <h4>
    {{ 'pages.role.title' | translate }}
  </h4>
  @if (isLoading) {
    <app-spinner [isLoading]="isLoading" />
  } @else {
    <div class="role-wrapper">
      <app-role [isSystemRoles]="true" [roles]="systemRoles" />
      <app-role [isSystemRoles]="false" [roles]="structuralUnitRoles" />
    </div>
  }
</div>
